import {useEffect} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {Button, ButtonWrapper} from '../../../../../../components/UI/Button'
import {SelectAsyncWrapper} from '../../../../../../components/UI/Form/Input'
import {OccupancyTableReportDTO} from '../../../../models/reports.model'
import {formatDateType4, formatDateUTC} from '../../../../../../util/dates'
import {
  getFilterGuestOccupancyTableList,
  getFilterEnterpriseOccupancyTableList,
  getFilterModuleOccupancyTableList,
  getFilterRoomOccupancyTableList,
  getFilterBedOccupancyTableList,
} from '../../../../services/report.service'

export const FormSubHeaderReportOccupancy = ({
  selectedOption,
  changeDate,
  setFechas,
  submitFn,
  setIsSearchEmp,
  setHasDataReport,
  setIdEmpresa,
}: any) => {
  const methods = useForm<any>()

  const {handleSubmit, setValue, watch, reset} = methods

  const onSubmit = async (dataForm: OccupancyTableReportDTO) => {
    setFechas({
      desde: formatDateUTC(formatDateType4(selectedOption.FechaDesde)),
      hasta: formatDateUTC(formatDateType4(selectedOption.FechaHasta)),
    })

    submitFn(dataForm)
  }

  const handleClear = () => {
    reset()
    setHasDataReport(false)
  }

  const loadOptionsGuest = async (inputValue: string, callback: (options: any[]) => void) => {
    try {
      if (inputValue.length < 3) {
        return []
      }
      const {data: response} = await getFilterGuestOccupancyTableList({
        FechaInicio: formatDateType4(selectedOption.FechaDesde) || '',
        FechaFin: formatDateType4(selectedOption.FechaHasta) || '',
        CampamentoId: selectedOption.CampamentoId || null,
        SiteId: selectedOption.SiteId || null,
        BuscaTexto: inputValue,
      })
      console.log(response)
      if (response.length > 0) {
        const mappedGuests = response?.map((guest: any) => ({
          value: guest.HuespedId,
          label: `${guest.HuespedNombres} ${guest.HuespedApPaterno} ${guest.HuespedApMaterno} ${guest.HuespedNroDoc}`,
          ...guest,
        }))
        return mappedGuests
      } else {
        return []
      }
    } catch (error) {
      console.error('Error fetching options:', error)
      return []
    }
  }
  const loadOptionsEnterprise = async (inputValue: string, callback: (options: any[]) => void) => {
    try {
      if (inputValue.length < 3) {
        return []
      }
      const {data: response} = await getFilterEnterpriseOccupancyTableList({
        FechaInicio: formatDateType4(selectedOption.FechaDesde) || '',
        FechaFin: formatDateType4(selectedOption.FechaHasta) || '',
        CampamentoId: selectedOption.CampamentoId || null,
        BuscaTexto: inputValue,
      })
      console.log(response)
      if (response.length > 0) {
        const mappedGuests = response?.map((guest: any) => ({
          value: guest.EmpresaId,
          label: `${guest.RucEmpresa} ${guest.RazonSocialEmpresa}`,

          ...guest,
        }))
        return mappedGuests
      } else {
        return []
      }
    } catch (error) {
      console.error('Error fetching options:', error)
      return []
    }
  }
  const loadOptionsModule = async (inputValue: string, callback: (options: any[]) => void) => {
    try {
      const {data: response} = await getFilterModuleOccupancyTableList({
        FechaInicio: formatDateType4(selectedOption.FechaDesde) || '',
        FechaFin: formatDateType4(selectedOption.FechaHasta) || '',
        CampamentoId: selectedOption.CampamentoId || null,
        SiteId: selectedOption.SiteId || '',
        BuscaTexto: inputValue,
      })
      if (response.length > 0) {
        const mappedGuests = response?.map((guest: any) => ({
          value: guest.ModuloId,
          label: guest.Codigo,
          ...guest,
        }))
        return mappedGuests
      } else {
        return []
      }
    } catch (error) {
      console.error('Error fetching options:', error)
      return []
    }
  }
  const loadOptionsRoom = async (inputValue: string, callback: (options: any[]) => void) => {
    try {
      const {data: response} = await getFilterRoomOccupancyTableList({
        FechaInicio: formatDateType4(selectedOption.FechaDesde) || '',
        FechaFin: formatDateType4(selectedOption.FechaHasta) || '',
        CampamentoId: selectedOption.CampamentoId || null,
        SiteId: selectedOption.SiteId || '',
        ModuloDetId: watch('ModuloId'),
        BuscaTexto: inputValue,
      })
      if (response.length > 0) {
        const mappedGuests = response?.map((guest: any) => ({
          value: guest.HabitacionId,
          label: guest.Codigo,
          ...guest,
        }))
        return mappedGuests
      } else {
        return []
      }
    } catch (error) {
      console.error('Error fetching options:', error)
      return []
    }
  }
  const loadOptionsBed = async (inputValue: string, callback: (options: any[]) => void) => {
    try {
      const {data: response} = await getFilterBedOccupancyTableList({
        FechaInicio: formatDateType4(selectedOption.FechaDesde) || '',
        FechaFin: formatDateType4(selectedOption.FechaHasta) || '',
        CampamentoId: selectedOption.CampamentoId || null,
        HabitacionDetId: watch('HabitacionId'),
        SiteId: selectedOption.SiteId || '',
        BuscaTexto: inputValue,
      })
      if (response.length > 0) {
        const mappedGuests = response?.map((guest: any) => ({
          value: guest.CamaId,
          label: guest.Codigo,
          ...guest,
        }))
        return mappedGuests
      } else {
        return []
      }
    } catch (error) {
      console.error('Error fetching options:', error)
      return []
    }
  }
  const getInformationColaborador = async (e: any) => {
    let value = e ? e : ''
    setValue('HuespedDetId', value.value)
    setValue('Huesped_descripcion', value.label)
  }
  const getInformationEnterprise = async (e: any) => {
    let value = e ? e : ''
    setIdEmpresa(value.value)
    setValue('EmpresaId', value.value)
    setValue('EmpresaNombre', value.label)
    setIsSearchEmp(true)
  }
  const getInformationModule = async (e: any) => {
    let value = e ? e : ''

    setValue('ModuloId', value.value)
    setValue('ModuloCodigo', value.label)
    setValue('HabitacionId', null)
    setValue('HabitacionCodigo', null)
    setValue('CamaId', null)
    setValue('CamaCodigo', null)
  }
  const getInformationRoom = async (e: any) => {
    let value = e ? e : ''
    setValue('HabitacionId', value.value)
    setValue('HabitacionCodigo', value.label)
    setValue('CamaId', '')
    setValue('CamaCodigo', '')
  }
  const getInformationBed = async (e: any) => {
    let value = e ? e : ''
    setValue('CamaId', value.value)
    setValue('CamaCodigo', value.label)
  }

  useEffect(() => {
    if (changeDate) {
      setValue('NroDocumento', '')
      setValue('HuespedId', '')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changeDate])

  return (
    <FormProvider {...methods}>
      <form className='m-2'>
        <div className='row'>
          <div className='col-sm-12 col-lg-4'>
            <SelectAsyncWrapper
              labelText='Datos del Huésped'
              name='HuespedDetId'
              loadOptions={loadOptionsGuest}
              onChangeValue={getInformationColaborador}
              value={{
                value: watch('HuespedDetId') || '',
                label: watch('Huesped_descripcion') || '',
              }}
            />
          </div>
          <div className='col-sm-12 col-lg-4'>
            <SelectAsyncWrapper
              labelText='Datos de la empresa'
              name='EmpresaId'
              loadOptions={loadOptionsEnterprise}
              onChangeValue={getInformationEnterprise}
              value={{
                value: watch('EmpresaId') || '',
                label: watch('EmpresaNombre') || '',
              }}
            />
          </div>
          <div className='col-sm-12 col-lg-4'>
            <SelectAsyncWrapper
              labelText='Modulo'
              name='ModuloId'
              loadOptions={loadOptionsModule}
              onChangeValue={getInformationModule}
              value={{
                value: watch('ModuloId') || '',
                label: watch('ModuloCodigo') || '',
              }}
            />
          </div>
          <div className='col-sm-12 col-lg-4'>
            <SelectAsyncWrapper
              labelText='Habitación'
              name='HabitacionId'
              loadOptions={loadOptionsRoom}
              onChangeValue={getInformationRoom}
              value={{
                value: watch('HabitacionId') || '',
                label: watch('HabitacionCodigo') || '',
              }}
            />
          </div>
          <div className='col-sm-12 col-lg-4'>
            <SelectAsyncWrapper
              labelText='Cama'
              name='CamaId'
              loadOptions={loadOptionsBed}
              onChangeValue={getInformationBed}
              value={{
                value: watch('CamaId') || '',
                label: watch('CamaCodigo') || '',
              }}
            />
          </div>
        </div>

        <ButtonWrapper className={'sdx-white-bg'}>
          <Button label='Buscar' onClick={handleSubmit(onSubmit)} />
          <Button typeBtn='button' label='Limpiar' onClick={handleClear} />
        </ButtonWrapper>
      </form>
    </FormProvider>
  )
}
